<template>
  <v-navigation-drawer
    v-model="drawerVal"
    app
    right
  >
    <v-list
      nav
    >
      <v-list-item
        v-for="(item,i) in drawerList"
        :key="i"
        link
        :to="item.route"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            {{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    drawer: {
      type: Boolean,
      default: false
    }

  },
  data () {
    return {
      drawerList: [
        { title: '快速訂房', icon: 'mdi-cursor-default-click', route: '/CampSearch' },
        { title: '我的訂單', icon: 'mdi-file-document-outline', route: '/OrderInfo/1' }, // isUser參數會登入後存localstorge，目前先用假資料
        { title: '入場憑證', icon: 'mdi-ticket-account' }
      ]
    }
  },
  computed: {
    drawerVal: {
      get () {
        // debugger
        return this.drawer
      },
      set (val) {
        // debugger
        // this.$emit('drawerCtrl', val)
        this.$emit('update:drawer', val)
      }
    }
  }
}
</script>

<style scoped>

</style>
